<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="settings != null"
>
     <m-edit-text
        label="Internal Label"
        v-model="settings.internal_label"
        v-on:input="upsert"
        hint="Customers will not see this"
        
    />
    
    <m-edit-text
        label="Banner Text"
        v-model="settings.banner_text"
        v-on:input="upsert"
        hint="This text will show when use logo is unchecked or no logo is available"
        :show_hint_everywhere="true"
    />

    <div
        style="display: inline-block; text-align: center; padding: 15px; width: 100%; margin-top: 15px; margin-bottom: 15px;"
    >

        <div
            :style="style_logo_background"
        >
            <img
                :src="settings.logo_image_url"
                :style="style_logo"
                v-if="settings.logo_image_url != null"
            />

            <v-icon
                v-if="settings.logo_image_url == null"
                size="250"
            >
                mdi-panorama-variant-outline
            </v-icon>
        </div>

        <br/>

        <v-icon
            style="margin-top: 7px; margin-bottom: 7px; margin-right: 15px;"
            v-on:click="onClickUploadLogo()"
        >
            mdi-upload
        </v-icon>

        <v-icon
            style="margin-top: 7px; margin-bottom: 7px;"
            v-on:click="onClickDeleteLogo()"
        >
            mdi-trash-can-outline
        </v-icon>

    </div>

    <v-checkbox
        label="Use Logo"
        v-model="settings.use_logo"
        v-on:change="upsert"
        :disabled="settings.logo_image_url == null"
    />

    <m-edit-blobs-dialog
        ref="upload-blob-dialog"
        title="Upload Logo"
        v-on:ok="afterUploadLogo($event)"
        :externally_visible="true"
        :show_send_as_links="false"
        :organization_id="settings.organization_id"
    />

    <m-edit-color-line
       label="Banner Background Color"
       v-model="settings.background_color"
       default_color="#FFFFFF"
       v-on:input="upsert"
    />

    <m-edit-text
        label="Max Width (px)"
        v-model="settings.image_max_width"
        v-on:input="upsert"
    />

    <m-edit-text
        label="Max Height (px)"
        v-model="settings.image_max_height"
        v-on:input="upsert"
    />

    <m-edit-text
        label="Logo Image Custom CSS"
        v-model="settings.logo_image_css"
        v-on:input="upsert"
        optional
    />

    <m-edit-text
        label="Logo Containing DIV Custom CSS"
        v-model="settings.logo_background_css"
        v-on:input="upsert"
        optional
    />

    <m-edit-text
        label="Default opt-in form using this banner branding"
        :value="default_opt_in_url"
        read_only
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            settings: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/branding/banner',
            
                {
                    'banner_id' : this.$route.params.banner_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.results.length > 0 )
                        this.settings = data.results[0];
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get settings');
                },
            );
        },

        upsert() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/branding/banner',
            
                this.settings,
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save settings');
                },
            );
        },

        onClickUploadLogo()
        {
            this.$refs['upload-blob-dialog'].showDialog([],true);
        },

        afterUploadLogo(blob_ids)
        {
            this.$rc.showSpinner();
            
            this.$rc.getBlobMetaDataMultiple(
                blob_ids,
            
                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.meta_data.length < 1 )
                        return;

                    this.settings.logo_image_blob_id = data.meta_data[0].blob_id;
                    this.settings.logo_image_url = 'https://files.redchirp.com/'+data.meta_data[0].object_name;
                    this.settings.use_logo = true;
                    this.upsert();

                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add image avatars');
                },
            );
        },

        onClickDeleteLogo()
        {
            this.$rc.confirm(
                'Remove Logo',
                'This logo will be removed.  Are you sure you wish to proceed?',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Remove Logo', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.settings.logo_image_url = null;
                    this.settings.logo_image_blob_id = null;
                    this.settings.use_logo = false;
                    this.upsert();
                }
            );
        },

    },

    computed: {
        title() {
            let settings = this.settings;
            
            if ( settings == null ) return 'Banner Branding';
            return settings.organization_label+': '+settings.internal_label;
        },

        style_logo() {
            let settings = this.settings;
            if ( settings == null ) return '';
            
            let extra_css = settings.logo_image_css == null ? '' : settings.logo_image_css;

            return `max-width: ${settings.image_max_width}px; max-height: ${settings.image_max_height}px; ` + extra_css;
        },

        style_logo_background() {
            let settings = this.settings;
            if ( settings == null ) return '';

            let extra_css = settings.logo_background_css == null ? '' : settings.logo_background_css;

            return `background-color: ${settings.background_color}; ` + extra_css;
        },

        default_opt_in_url() 
        {
            if ( this.settings == null ) 
                return null;

            if ( this.$rc.getEnvironment() == 'dev' )
                return 'http://127.0.0.1:8081/app/opt-in/default/'+this.settings.organization_id+'/'+this.settings.banner_id;

            return 'https://app.redchirp.com/app/opt-in/default/'+this.settings.organization_id+'/'+this.settings.banner_id;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>